import { useAppSelector } from '../../../hooks/redux'
import { Strings } from '../../../constants/Strings'
import { Colors } from '../../../constants/Colors'
import style from './ResponseWarning.module.css'

interface Props {
    warning: number | null
}

let ResponseWarning = ({warning}: Props) => {

    const theme = useAppSelector<string>(state => state.theme.theme)
    const language = useAppSelector<string>(state => state.language.language)

    return (
        <div
            className={style.container}
            style={{
                border: `1px solid ${Colors[theme ?? 'light'].borderLight}`,
                color: Colors[theme ?? 'light'].text,
                backgroundColor: Colors[theme ?? 'light'].secondBackground,
                //boxShadow: `0px 0px 5px ${Colors[theme ?? 'light'].shadow}`
            }}
        >
            {warning
                ? <>
                    <div className={style.icon}>
                        <i className="fas fa-circle-exclamation"></i>
                    </div>
                    <div className={style.text}>
                        {Strings[language ?? 'tm']['warning' + warning]}!
                    </div>
                </>
                : null
            }
        </div>
    )
}

export default ResponseWarning